export const HIDE_ON_MOBILE = 'desktop-only'
export const SHOW_ON_MOBILE = 'mobile-only'
export const DEFAULT_CURSOR = 'default-cursor'
export const ELLIPSES = '...'

export interface PaginationInfo {
    previousPage: number | null
    nextPage: number | null
    pageNumbers: any[]
}

export const generatePaginationInfo = (
    selectedPage: number,
    totalPages: number
): PaginationInfo => {
    const previousPage = selectedPage - 1 > 0 ? selectedPage - 1 : null
    const nextPage = selectedPage + 1 <= totalPages ? selectedPage + 1 : null
    const paginationInfo = {
        previousPage,
        nextPage,
        pageNumbers: [
            1,
            ELLIPSES,
            previousPage + HIDE_ON_MOBILE,
            selectedPage,
            nextPage + HIDE_ON_MOBILE,
            ELLIPSES,
            totalPages,
        ],
    }

    if (totalPages <= 5) {
        return {
            ...paginationInfo,
            pageNumbers: Array.from(
                { length: totalPages },
                (_, key) => key + 1
            ),
        }
    }

    // first page is selected
    if (selectedPage === 1) {
        return {
            ...paginationInfo,
            pageNumbers: [
                selectedPage,
                nextPage!,
                (nextPage ? nextPage + 1 : 1) + HIDE_ON_MOBILE,
                ELLIPSES,
                totalPages,
            ],
        }
    }

    // second or third selected
    if (selectedPage === 2 || selectedPage === 3) {
        let pageNumbers = [
            previousPage!,
            selectedPage,
            nextPage!,
            ELLIPSES,
            totalPages,
        ]
        if (selectedPage === 3) {
            pageNumbers = [
                1,
                previousPage + HIDE_ON_MOBILE,
                ELLIPSES + SHOW_ON_MOBILE,
                selectedPage,
                nextPage + HIDE_ON_MOBILE,
                ELLIPSES,
                totalPages,
            ]
        }
        return { ...paginationInfo, pageNumbers }
    }

    // second or third to last is selected
    if (selectedPage === totalPages - 1 || selectedPage === totalPages - 2) {
        let pageNumbers = [1, ELLIPSES, previousPage!, selectedPage, nextPage!]
        if (selectedPage === totalPages - 2) {
            pageNumbers = [
                1,
                ELLIPSES,
                previousPage + HIDE_ON_MOBILE,
                selectedPage,
                ELLIPSES + SHOW_ON_MOBILE,
                nextPage + HIDE_ON_MOBILE,
                totalPages,
            ]
        }
        return { ...paginationInfo, pageNumbers }
    }

    // last page is selected
    if (selectedPage === totalPages) {
        return {
            ...paginationInfo,
            pageNumbers: [
                1,
                ELLIPSES,
                previousPage! - 1,
                previousPage!,
                selectedPage,
            ],
        }
    }

    return paginationInfo
}

export const generateClassNamesForStyling = (value: string) => {
    const classNames: string[] = []
    if (value.endsWith(HIDE_ON_MOBILE)) {
        classNames.push(HIDE_ON_MOBILE)
    } else if (value.endsWith(SHOW_ON_MOBILE)) {
        classNames.push(SHOW_ON_MOBILE)
    }

    if (value.startsWith(ELLIPSES)) {
        classNames.push(DEFAULT_CURSOR)
    }

    return classNames
}
